export default __webpack_public_path__ + "static/media/49.d92b6454.jpeg";